import React from 'react'
import PropTypes from 'prop-types'

const UserMerchant = ({ children }) => (
  <a href={'/merchant/account'} className="flex items-center text-sm">
    {children}
  </a>
)

UserMerchant.propTypes = {
  children: PropTypes.node,
}

export default UserMerchant
